var _circle, _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36.5,
    r: 36.266,
    fill: "url(#paint0_linear_506_3306)",
    stroke: "#81A9D7",
    strokeWidth: 0.467949
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5165 21.6545C77.5894 21.612 77.663 21.569 77.7374 21.5256C78.3617 21.1614 78.9668 20.8454 79.5552 20.5751C82.2679 25.2587 83.8207 30.698 83.8207 36.5C83.8207 54.074 69.5742 68.3205 52.0002 68.3205C34.4262 68.3205 20.1797 54.074 20.1797 36.5C20.1797 31.6712 21.2553 27.0936 23.18 22.9937C23.5112 23.1038 23.838 23.2148 24.1612 23.3245C28.3328 24.7409 31.9026 25.953 36.5579 22.4615C44.0451 16.8461 52.9361 17.3141 61.8271 21.5256C70.6091 25.6855 71.6497 25.0782 77.5165 21.6545Z",
    fill: "url(#paint1_linear_506_3306)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_506_3306)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 35.5,
    rx: 41.5,
    ry: 16.5,
    fill: "#FFF28E",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.192 31.628H43.852V31.112H39.304V30.056H43.852V29.48L40.276 29.624L40.072 28.628C43.24 28.54 46.008 28.38 48.376 28.148L48.748 29.156C47.636 29.252 46.42 29.336 45.1 29.408V30.056H49.672V31.112H45.1V31.628H48.772V35.804H45.1V36.368H49.252V37.352H45.1V37.94H49.852V39.008H39.148V37.94H43.852V37.352H39.748V36.368H43.852V35.804H40.192V31.628ZM47.56 34.82V34.172H45.1V34.82H47.56ZM43.852 34.82V34.172H41.404V34.82H43.852ZM41.404 33.236H43.852V32.612H41.404V33.236ZM45.1 32.612V33.236H47.56V32.612H45.1ZM55.696 28.232H56.932V29.252H61.468V30.416H56.932V31.592H60.736V35.744H52.456V31.592H55.696V28.232ZM59.488 34.592V32.756H53.704V34.592H59.488ZM53.476 36.596C53.028 37.644 52.528 38.528 51.976 39.248L50.944 38.492C51.52 37.82 52.016 37.02 52.432 36.092L53.476 36.596ZM55.396 36.488C55.612 37.192 55.824 38.016 56.032 38.96L54.772 39.26C54.636 38.364 54.452 37.52 54.22 36.728L55.396 36.488ZM57.88 36.32C58.216 37.112 58.516 37.984 58.78 38.936L57.532 39.236C57.316 38.212 57.04 37.32 56.704 36.56L57.88 36.32ZM60.268 36.032C61.012 37.016 61.588 37.868 61.996 38.588L60.94 39.308C60.524 38.516 59.96 37.64 59.248 36.68L60.268 36.032ZM42.424 43.196C42.88 43.812 43.312 44.464 43.72 45.152L43.024 45.5H45.388C45.804 44.852 46.18 44.056 46.516 43.112L47.74 43.448C47.468 44.216 47.152 44.9 46.792 45.5H49.012V46.724H45.136V47.012C45.112 47.548 45.056 48.068 44.968 48.572H49.708V49.796H45.568C46.144 51.172 47.624 52.268 50.008 53.084L49.264 54.272C46.8 53.264 45.212 51.936 44.5 50.288C44.276 50.816 44.024 51.276 43.744 51.668C42.928 52.748 41.596 53.576 39.748 54.152L39.064 53.06C40.896 52.468 42.14 51.716 42.796 50.804C43.012 50.476 43.188 50.14 43.324 49.796H39.292V48.572H43.684C43.78 48.092 43.84 47.572 43.864 47.012V46.724H39.976V45.5H42.472C42.072 44.82 41.672 44.236 41.272 43.748L42.424 43.196ZM52.204 43.232C53.004 43.824 53.7 44.42 54.292 45.02L53.404 45.92C52.916 45.36 52.216 44.756 51.304 44.108L52.204 43.232ZM51.916 46.052C52.7 46.652 53.36 47.252 53.896 47.852L53.008 48.74C52.528 48.18 51.868 47.572 51.028 46.916L51.916 46.052ZM54.244 49.916C53.724 51.404 53.128 52.816 52.456 54.152L51.196 53.6C51.9 52.304 52.54 50.92 53.116 49.448L54.244 49.916ZM54.568 45.032H57.592C57.4 44.496 57.164 43.956 56.884 43.412L58.048 43.076C58.4 43.828 58.66 44.48 58.828 45.032H61.744V46.256H58.816V48.692H61.42V49.892H58.816V52.628H61.996V53.852H54.28V52.628H57.556V49.892H54.904V48.692H57.556V46.256H54.568V45.032Z",
    fill: "#112C56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_506_3306",
    x: 0.0179482,
    y: 8.51795,
    width: 103.964,
    height: 53.9641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24103,
    result: "effect1_foregroundBlur_506_3306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_3306",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16547B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_3306",
    x1: 83.8207,
    y1: 36.868,
    x2: 20.1797,
    y2: 36.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#FFEF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB342"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.45c1d5fc017c83d426ff7fcc207bffae.svg";
export { ForwardRef as ReactComponent };